import { isFunc } from "@insightfulscience/shared-utils/fn";
import { isKeyMatch } from "./keys";

const HotKeyListener = (node = global.document, eventName = "keyup") => {
	const handlers = [];
	let isListening = false;

	const eventListener = event => handlers.find(handler => handler(event));

	const updateListener = () => {
		if (node == null) return;

		if (handlers.length > 0 && !isListening) {
			node.addEventListener(eventName, eventListener);
			isListening = true;
		}

		if (handlers.length === 0 && isListening) {
			node.removeEventListener(eventName, eventListener);
			isListening = false;
		}
	};

	const remove = callback => {
		const index = handlers.indexOf(callback);
		if (index < 0) return;
		handlers.splice(index, 1);
		updateListener();
	};

	const wrapCallback = (keyPattern, callback, once) => {
		const wrapped = event => {
			if (!isKeyMatch(keyPattern, event)) return false;
			callback(event);
			if (once) remove(wrapped);
			return true;
		};

		return wrapped;
	};

	const addHandler = (keyPattern, callback, once) => {
		if (!isFunc(callback)) return () => {};

		const handler = wrapCallback(keyPattern, callback, once);
		handlers.unshift(handler);

		updateListener();
		return () => remove(handler);
	};

	const clear = () => {
		handlers.splice(0, handlers.length);
		updateListener();
	};

	return {
		addHandler, //
		clear,
	};
};

export default HotKeyListener;
